import PropTypes from 'prop-types';

import formatDate from 'components/utils/formatDate';

export default function TrainingStatus({ row }) {
  if (row.attributes.training_completed_at) {
    const trainingCompletedAt = new Date(row.attributes.training_completed_at);

    return `Completed on ${formatDate(trainingCompletedAt)}`;
  }

  if (row.attributes.training_approved_at) {
    const trainingApprovedAt = new Date(row.attributes.training_approved_at);

    return `Approved on ${formatDate(trainingApprovedAt)}`;
  }

  if (row.attributes.training_requested_at) {
    const trainingRequestedAt = new Date(row.attributes.training_requested_at);

    return `Requested on ${formatDate(trainingRequestedAt)}`;
  }

  return 'Not requested';
}

TrainingStatus.propTypes = {
  row: PropTypes.object.isRequired,
};
